module.exports = __webpack_public_path__ + "static/media/HybridCG.96045c33.png";